import React from 'react'
import PropTypes from 'prop-types'
import { DotLoading, Card } from 'antd-mobile'

class AddressButton extends React.PureComponent {
  static defaultProps = {
    loading: false,
    addressId: '',
    address: {},
    // onClick: function () {},
    placeholder: '请选择收货地址'
  }
  static propTypes = {
    loading: PropTypes.bool,
    addressId: PropTypes.string,
    address: PropTypes.object,
    onClick: PropTypes.func,
    placeholder: PropTypes.string
  }

  render () {
    const {
      loading,
      addressId,
      address,
      placeholder,
      onClick
    } = this.props

    return <Card  onClick={onClick} className={'!rounded-none border-b-2'} style={{borderColor: 'var(--adm-color-primary)'}}>
      <div className={'flex justify-between items-center h-12'}>
        <div className={'flex-shrink-0 flex-grow-0 pr-4'}><i className={'icon-font icon-map'}/></div>
        <div className={'flex-auto'}>
          {
            loading
              ? <DotLoading/>
              : <div className={'text-xs'}>
                {
                  addressId
                    ? <div>
                      <div>{address.name} {address.phone}</div>
                      <div>{address.region} {address.address}</div>
                    </div>
                    : <span className={'text-gray-500'}>{placeholder}</span>
                }
              </div>
          }
        </div>
        {onClick && <div className={'flex-shrink-0 flex-grow-0 pl-4'}>
          <i className={'icon-font icon-arrow-right-bold'}/>
        </div>}
      </div>
    </Card>
  }
}

export { AddressButton }
